import { OInfoPage } from "@dnvgl-onefoundation/onedesign-react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../store";
import NotFoundPage from "./NotFoundPage";

const MaintenancePage = () => {
  const { isLoading, data } = useSelector(
    (state: ApplicationState) => state.init
  );

  if (!isLoading && !data.maintenanceMode?.isEnabled) {
    return <NotFoundPage />;
  } else {
    return (
      <div style={{ height: "800px" }}>
        <OInfoPage iconClass="fa-cogs">
          <h2 className="info-page-title">Sorry for the inconvenience.</h2>
          <p>The website is currently undergoing maintenance, please come back later</p>
        </OInfoPage>
      </div>
    );
  }
};

export default MaintenancePage;
